<h3-annotation-layout>
  <h3-layers projection-location="main-image" *ngIf="state.status === 'ready'">
  </h3-layers>

  <ng-container
    projection-location="right-collapsing-section"
    *ngIf="state.status === 'ready'"
  >
    <h3-vector-tagging-shape-list-and-tag-editor
      *ngIf="(activeLayerType$ | async) === 'vector_tagging'"
    >
    </h3-vector-tagging-shape-list-and-tag-editor>
  </ng-container>

  <ng-container
    projection-location="toolbars"
    *ngIf="state.status === 'ready'"
    [ngSwitch]="activeLayerType$ | async"
  >
    <h3-cv-feedback-panel></h3-cv-feedback-panel>

    <h3-vector-tagging-toolbars
      *ngSwitchCase="'vector_tagging'"
      [state]="state"
    ></h3-vector-tagging-toolbars>
    <h3-raster-coding-toolbars
      *ngSwitchCase="'raster_coding'"
      [state]="state"
    ></h3-raster-coding-toolbars>
  </ng-container>
</h3-annotation-layout>
